import React from "react";
import { FormattedMessage } from 'react-intl';
function FormErrors(props) {
  if (
    props.formerrors &&
    (props.formerrors.blankfield)
  ) {
    return (
      <div className="error container help is-danger" style={{textAlign:"center"}}>
          {props.formerrors.blankfield ? <div style={{color:'white',backgroundColor:'red'}}><FormattedMessage id="allfieldreq" /></div>  : ""}
      </div>
    );
  } else if (props.formerrors && props.formerrors.cognito) {
    return (
      <div className="error container help is-danger">
        <div className="row justify-content-center">
          {props.formerrors.cognito.message}
        </div>
      </div>
    );
  } else {
    return <div />;
  }
}

export default FormErrors;